import { Vue, Component, Prop } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";

@Component({
    components: { ValidationProvider },
})
export default class FormInput extends Vue {
    @Prop({ type: Boolean })
    public dense: boolean;

    @Prop({ type: Boolean })
    public hideDetails: boolean;

    @Prop({ type: String })
    public itemText: string;

    @Prop({ type: String })
    public itemValue: string;

    @Prop({ type: String })
    public rules: string;

    @Prop({ type: String })
    public name: string;

    @Prop({ type: String })
    public label: string;

    @Prop({ type: Boolean })
    public required: Boolean;

    @Prop({ type: Boolean, default: false })
    public textarea: Boolean;

    @Prop()
    value;

    @Prop()
    public change;

    mounted() {}
}
